import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import HotelPageCategoryTile from './HotelPageCategoryTile'
import type { CategoryData } from './types'
import { generateCategorySearchUrl } from 'lib/url/searchUrlUtils'

interface Props {
  category: CategoryData
}

function HotelPageSearchHotelCategoryTile(props: Props) {
  const { category } = props
  const intl = useIntl()

  const categorySearchUrl = useMemo(() => generateCategorySearchUrl({
    parameterName: category.parameterName,
    parameterValue: category.parameterValue,
  }), [category])

  const actionText = useMemo(() => {
    return intl.formatMessage({
      id: 'ECuUjCAWXi',
      defaultMessage: 'View offers',
      description: 'Action text for hotel category tile',
    })
  }, [intl])

  return <HotelPageCategoryTile
    toUrl={categorySearchUrl}
    category={category}
    actionText={actionText}
  />
}

export default HotelPageSearchHotelCategoryTile
